export default __webpack_public_path__ + "img/logoACIQUI.688f6ea3.svg";